module.exports = __webpack_public_path__ + "img/winerack10.76af8029.jpg";